export function TitleMedium({children, color, fontWeight = 500}) {
    return (
        <span style={{
            lineHeight: '1.05em',
            fontFamily: 'Open Sans',
            fontSize: '1em',
            color,
            fontWeight,
        }}>{children}</span>
    );
}
